<template lang="pug">
.list-shipments
  SspLayout(area="tnt")
    template(slot="actions")
      transition(name="fade")
        .search-error-message(v-if="searchError") {{searchError}}
      form(@submit.prevent="searchShipment()").search.input-group
        input.form-control.code-filter-input(v-model="code" placeholder="Enter Code")
        span.input-group-btn
          button.btn.btn-default.search-for-code-button(:disabled="!isValid")
            i.fa.fa-search
      .spacer
      router-link.btn.btn-primary.new-shipment-button(:to="{name: 'newShipment'}")
        i.fa.fa-plus
        span.ml5 New Shipment
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th ID
        th Reference
        th.hidden-xs Created
        th Size
        th Status
        th.hidden-xs Closed
        th.hidden-xs Shipped
        th
      tr(v-for="shipment in shipments")
        td {{shipment.id}}
        td {{shipment.externalReference}}
        td.hidden-xs {{shipment.created | date}}
        td {{shipment.size}}
        td {{shipment.status | replaceUnderscore}}
        td.hidden-xs {{shipment.closed | date}}
        td.hidden-xs {{shipment.shipped | date}}
        td.actions
          router-link.btn-view(:to="{ name: 'shipment', params: { id: shipment.id } }") View
</template>
<script>
import DataGrid from '@/components/ssp/DataGrid'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { dateFilter, replaceUnderscore } from '@/filters/filters'
import Util from '@/service/Util'

export default {
  data: () => ({
    shipments: [],
    code: null,
    searchError: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return TrackNTrace.listShipments(req)
        .then((resp) => {
          this.shipments = resp.data.content
          return resp.data.totalElements
        })
    },
    searchShipment() {
      TrackNTrace.findShipmentByCode(Util.sanitizeCode(this.code))
        .then((resp) => {
          this.$router.push(`/trackntrace/shipment/${resp.data.id}/view`)
        })
        .catch((e) => {
          if (e.response.status === 400 || e.response.status === 404) {
            this.searchError = e.response.data.message
          } else {
            this.$emit('error', e)
          }
        })
    }
  },
  watch: {
    code() {
      this.searchError = null
    }
  },
  computed: {
    isValid() {
      return this.code
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter,
    replaceUnderscore
  }
}
</script>
<style lang="scss">
.list-shipments {
  .search-error-message {
    color: red;
    padding: 5px;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/shipments/ListShipments.vue